import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  type EntityCertificationsParams,
  fetchEntityCertifications,
} from '@/api/my-styles';

export function entityCertificationsQueryOptions(
  entityId: string,
  params: EntityCertificationsParams,
) {
  return queryOptions({
    queryKey: ['my-styles', 'certifications', entityId, params] as const,
    queryFn: () => fetchEntityCertifications(entityId, params),
    enabled: !!entityId,
    staleTime: 60_000,
  });
}

export function useEntityCertificationsQuery(
  entityId: string,
  params: EntityCertificationsParams,
) {
  return useQuery(entityCertificationsQueryOptions(entityId, params));
}
